import { useState, useEffect, useCallback } from "react";
import ThemeContext from "./ThemeContext";

const getInitialTheme = () => {
  // 1. respect a previous choice
  const saved = localStorage.getItem("theme");
  if (saved === "light" || saved === "dark") return saved;
  // 2. otherwise follow the OS preference
  if (window.matchMedia("(prefers-color-scheme: dark)").matches) return "dark";
  return "light";
};

const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
